"use client";

import { useEffect, type ReactNode } from "react";

import { QueryProvider } from "./query-provider";
import { RealtimeProvider } from "@/realtime";
import { useAppStore } from "@/stores/app-store";

export function AppProviders({ children }: { children: ReactNode }) {
  const setHydrated = useAppStore((state) => state.setHydrated);

  useEffect(() => {
    setHydrated(true);
  }, [setHydrated]);

  return (
    <QueryProvider>
      <RealtimeProvider>{children}</RealtimeProvider>
    </QueryProvider>
  );
}
